import Link from 'next/link'
import type { Column } from '@/types/newt/column'
import { Time } from '@/components/parts/time'
import { getAuthorName } from '@/utils/newt/author'

export function ColumnList({ column }: { column: Column }) {
  return (
    <>
      <li>
        <Link
          href={`/column/${column.slug}/`}
          className={
            'flex flex-col gap-y-[0.5rem] justify-between w-full h-full bg-white rounded-lg border border-gray shadow-[0_4px_24px_rgba(199,189,168,.08)] overflow-hidden group/item pb-4'
          }
        >
          <div>
            <div className={'aspect-video overflow-hidden'}>
              <img
                className={
                  'w-full h-full object-cover transition-transform group-hover/item:scale-110 duration-500 ease-in-out will-change-transform'
                }
                src={column.eyecatch.src}
                alt={''}
              />
            </div>
            <h3 className={'text-base font-bold leading-[1.7] mt-2 px-5'}>
              {column.title}
            </h3>
          </div>
          <div className={'px-5 mt-2'}>
            <ul className={'flex font-bold text-[11px]'}>
              <li
                className={
                  'text-sm lg:text-xs bg-secondary text-white px-2 py-1 rounded-[4px]'
                }
              >
                {column.columnCategory.map((category) => (
                  <div key={category._id}>{category.name}</div>
                ))}
              </li>
            </ul>
            {/* <ul className={'inline-flex flex-wrap gap-1 mt-2'}>
                <li
                  className={
                    'text-sm lg:text-xs text-secondary leading-[1.7] bg-[#E6F2FD] px-2 py-1 rounded-[4px]'
                  }
                >{column.columnTag}</li>
            </ul> */}
            <div className={'flex items-center mt-2'}>
              <div className={'flex items-center gap-x-[6px]'}>
                <svg
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.30113 9.79535H1.61931C1.35633 9.79535 1.14204 9.58153 1.14204 9.31808V5.02262H8.7784V9.31808C8.7784 9.58153 8.56458 9.79535 8.30113 9.79535ZM1.61931 2.15913H2.57386V2.6364C2.57386 2.89985 2.78768 3.11367 3.05113 3.11367C3.31458 3.11367 3.5284 2.89985 3.5284 2.6364V2.15913H6.39204V2.6364C6.39204 2.89985 6.60538 3.11367 6.86931 3.11367C7.13324 3.11367 7.34658 2.89985 7.34658 2.6364V2.15913H8.30113C8.56458 2.15913 8.7784 2.37342 8.7784 2.6364V4.06822H1.14204V2.6364C1.14204 2.37342 1.35633 2.15913 1.61931 2.15913ZM8.30114 1.20455H7.34659V0.727273C7.34659 0.463818 7.13325 0.25 6.86932 0.25C6.60539 0.25 6.39205 0.463818 6.39205 0.727273V1.20455H3.52841V0.727273C3.52841 0.463818 3.31459 0.25 3.05114 0.25C2.78768 0.25 2.57386 0.463818 2.57386 0.727273V1.20455H1.61932C0.829909 1.20455 0.1875 1.84695 0.1875 2.63636V9.31818C0.1875 10.1076 0.829909 10.75 1.61932 10.75H8.30114C9.09054 10.75 9.73295 10.1076 9.73295 9.31818V2.63636C9.73295 1.84695 9.09054 1.20455 8.30114 1.20455Z"
                    fill="black"
                  />
                </svg>
                <Time
                  gmt={column.overwriteCreatedAt}
                  className={'mr-4 text-xs'}
                />
              </div>
              <div className={'flex items-center gap-x-[6px]'}>
                <svg
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.9125 5.71875C3.4425 5.71875 2.2875 4.56375 2.2875 3.09375C2.2875 1.62375 3.4425 0.46875 4.9125 0.46875C6.3825 0.46875 7.5375 1.62375 7.5375 3.09375C7.5375 4.56375 6.3825 5.71875 4.9125 5.71875ZM4.9125 1.51875C4.02 1.51875 3.3375 2.20125 3.3375 3.09375C3.3375 3.98625 4.02 4.66875 4.9125 4.66875C5.805 4.66875 6.4875 3.98625 6.4875 3.09375C6.4875 2.20125 5.805 1.51875 4.9125 1.51875ZM8.5875 10.4437C8.5875 10.7587 8.7975 10.9688 9.1125 10.9688C9.4275 10.9688 9.6375 10.7587 9.6375 10.4437V9.39375C9.6375 7.92375 8.4825 6.76875 7.0125 6.76875H2.8125C1.3425 6.76875 0.1875 7.92375 0.1875 9.39375V10.4437C0.1875 10.7587 0.3975 10.9688 0.7125 10.9688C1.0275 10.9688 1.2375 10.7587 1.2375 10.4437V9.39375C1.2375 8.50125 1.92 7.81875 2.8125 7.81875H7.0125C7.905 7.81875 8.5875 8.50125 8.5875 9.39375V10.4437Z"
                    fill="black"
                  />
                </svg>
                {getAuthorName(column)}
              </div>
            </div>
          </div>
        </Link>
      </li>
    </>
  )
}
